import { render, staticRenderFns } from "./WelcomeCeremony.vue?vue&type=template&id=454a5561"
import script from "./WelcomeCeremony.vue?vue&type=script&lang=js"
export * from "./WelcomeCeremony.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports